import { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ModulePane } from '../components/ModulePane/ModulePane';
import { useCan } from '../lib/identity';
import { LibraryTab } from './admin/LibraryTab';
import { UserAccessTab } from './admin/UserAccessTab';
import styles from './Admin.module.css';

type Tab = 'library' | 'users';

export function Admin() {
  const canEditLibrary = useCan('editLibrary');
  const canManageUsers = useCan('manageUsers');

  // Default to whichever the user can access.
  const [tab, setTab] = useState<Tab>(canEditLibrary ? 'library' : 'users');

  // No admin capability at all → bounce home.
  if (!canEditLibrary && !canManageUsers) {
    return <Navigate to="/" replace />;
  }

  const sidebar = (
    <>
      <Link to="/" className={styles.back}>← Back to drafts</Link>
      <nav className={styles.adminNav}>
        {canEditLibrary && (
          <button
            type="button"
            className={`${styles.navItem} ${tab === 'library' ? styles.navItemActive : ''}`}
            onClick={() => setTab('library')}
          >
            Library
          </button>
        )}
        {canManageUsers && (
          <button
            type="button"
            className={`${styles.navItem} ${tab === 'users' ? styles.navItemActive : ''}`}
            onClick={() => setTab('users')}
          >
            User access
          </button>
        )}
      </nav>
    </>
  );

  return (
    <ModulePane sidebar={sidebar} ariaLabel="Admin">
      {tab === 'library' && canEditLibrary && <LibraryTab />}
      {tab === 'users' && canManageUsers && <UserAccessTab />}
    </ModulePane>
  );
}
